/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Samples_LabelInputs */

const en_samples_label = /** @type {(inputs: Samples_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Label`)
};

const es_samples_label = /** @type {(inputs: Samples_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etiqueta`)
};

/**
* | output |
* | --- |
* | "Label" |
*
* @param {Samples_LabelInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const samples_label = /** @type {((inputs?: Samples_LabelInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Samples_LabelInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_samples_label(inputs)
	return es_samples_label(inputs)
});